module.exports = __webpack_public_path__ + "img/accounts.weekly.6c429f7b.png";